import React, { memo } from 'react'

import { Row } from '@ublique/components/Grid'
import Button from '@ublique/components/Button'

const Footer = ({ t, onCancel }) => {
  return (
    <Row className='buttons-footer creation-step'>
      <Button kind='secondary' onClick={onCancel}>
        {t('SECONDARY_BUTTON_LABEL')}
      </Button>
      <Button type='submit'>{t('PRIMARY_BUTTON_LABEL')}</Button>
    </Row>
  )
}

export default memo(Footer)
